<template>
	<div class="c-loading-animation">
		<object
			class="c-loading-animation__visual"
			data="assets/images/loading-animation/animation.svg"
			type="image/svg+xml"
		/>
	</div>
</template>

<script lang="ts">
import Component from 'vue-class-component';
import Vue from 'vue';

@Component({
	components: {},
	componentId: 'C040'
})
export default class LoadingAnimation extends Vue {}
</script>
